import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">
          专题合集
        </h2>
        <p className="text-sm text-foreground-500 mb-8">按主题分类，总有一款适合你</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexData.slice(0, 4).map((item) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer group"
            >
              <span className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg mb-3">
                <i className={`${item.icon} text-primary-600 text-lg`}></i>
              </span>
              <h3 className="text-sm font-bold text-foreground-950 font-heading mb-1 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-2">{item.desc}</p>
              <span className="text-xs text-primary-500 font-medium">{item.count}</span>
            </a>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
          {indexData.slice(4).map((item) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-accent-200 transition-all duration-200 cursor-pointer group"
            >
              <span className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg mb-3">
                <i className={`${item.icon} text-accent-600 text-lg`}></i>
              </span>
              <h3 className="text-sm font-bold text-foreground-950 font-heading mb-1 group-hover:text-accent-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-2">{item.desc}</p>
              <span className="text-xs text-accent-500 font-medium">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}